import $ from "jquery";

const $window = $(window);
const $body = $(".page__body");

triggerResizeEvents();
triggerWheelEvents();
triggerScrollEvents();

function triggerResizeEvents() {
  const prevWinSize = {
    height: $window.height(),
    width: $window.width(),
  };

  $window.on("resize", function () {
    const nextWinSize = {
      height: $window.height(),
      width: $window.width(),
    };

    if (nextWinSize.height !== prevWinSize.height) {
      window.dispatchEvent(new Event("resize:height", { bubbles: true }));
    }
    if (nextWinSize.width !== prevWinSize.width) {
      window.dispatchEvent(new Event("resize:width", { bubbles: true }));
    }

    [prevWinSize.height, prevWinSize.width] = [
      nextWinSize.height,
      nextWinSize.width,
    ];
  });
}

function triggerWheelEvents() {
  $window.on("wheel", function (event) {
    if (event.originalEvent.deltaY !== 0) {
      if (event.originalEvent.deltaY < 0) {
        window.dispatchEvent(new Event("wheel:up", { bubbles: true }));
      } else {
        window.dispatchEvent(new Event("wheel:down", { bubbles: true }));
      }
    }
  });
}

function triggerScrollEvents() {
  let prevScrollTop = 0;

  $body.on("scroll", function () {
    let nextScrollTop = $(this).scrollTop();

    if (nextScrollTop > prevScrollTop) {
      window.dispatchEvent(new Event("scroll:down", { bubbles: true }));
    } else {
      window.dispatchEvent(new Event("scroll:up", { bubbles: true }));
    }

    prevScrollTop = nextScrollTop;
  });
}
